import React, {type FC} from 'react'
import {Button, Text, useGetAdaptiveStyle} from 'uikit'
import {useAppSelector, useAppDispatch} from 'store'
import {getTranslates} from 'store/translates/selectors'
import {hideModalThunk} from 'store/modal/thunk'
import {adaptiveConfigModal} from 'src/common/components/GamePage/consts'
import kubok from 'src/img/kubok_min.png'
import {ModalWrap} from '../ModalWrap'
import styles from './CongratulateModal.scss'


export const CongratulateModal: FC<{}> = () => {
  const {style} = useGetAdaptiveStyle(adaptiveConfigModal)
  const dispatch = useAppDispatch()
  const translates = useAppSelector(getTranslates);

  const handleClose = () => dispatch(hideModalThunk(null))

  return (
    <ModalWrap classes={{modal: styles.wrapper}} style={style}>
      <Text type="title" color="congrat">{translates.CONGRATULATE}</Text>
      <Text type="title" color="congrat">{translates.YOU_GUESS_ALL_WORDS}</Text>
      <img src={kubok} className={styles.imgStyle}></img>
      <Text type="text" color="congrat">{translates.SEE_SOON}</Text>
      <Text type="text" color="congrat">{translates.TRY_OTHER_LANG}</Text>
      <Button className={styles.closeBtn} onClick={handleClose}>{translates.CLOSE}</Button>
    </ModalWrap>
  )
}
